<template>
  <div class="button fRow jCenter aCenter transition-fast"
    v-ripple
    v-bind:class="{flat: flat, fab: fab, mini: mini, invert: invert, wide: wide, fav: fav}">
    <i class="material-icons-round">{{ic}}</i>
    <label>{{label}}</label>
  </div>
</template>

<script>
export default {
  props: ['label', 'ic', 'fab', 'mini', 'flat', 'mode', 'invert', 'wide', 'fav'],
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
    mainClass() {
      let className = '';
      if (this.flat) {
        className += 'flat ';
      }
      if (this.fab) {
        className += 'fab ';
      }
      if (this.mini) {
        className += 'mini ';
      }
      alert(className);
      return className;
    },
    bc() {
      let a = '';
      switch (this.mode) {
        case 'success': {
          a = '#40aa45';
          break;
        }
        case 'error': {
          a = '#be2c00';
          break;
        }
        case 'warn': {
          a = '#cfa122';
          break;
        }
        case 'disabled': {
          a = '#0e0e0e33';
          break;
        }
        default: {
          a = '#578dd5';
          break;
        }
      }
      return a;
    },
  },
};
</script>

<style lang="scss" scoped>

.button {
  border-radius: 32px;
  padding: 8px 16px;
  background-color: var(--primary);
  cursor: pointer;
  opacity: 0.95;
  * {
    pointer-events: none;
  }
  i {
    margin-left: 8px;
    color: var(--themeWhite);
  }
  label {
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    white-space: nowrap;
    color: var(--themeWhite);
  }
}
.button.invert {
  i {
    color: var(--themeBlack4);
  }
  label {
    color: var(--themeBlack);
  }
}
.button.flat {
  background-color: var(--normalText05) !important;
  i {
    color: var(--normalText5);
  }
  label {
    color: var(--normalText);
  }
}
.button.fab {
  $fsize: 56px;
  width: $fsize;
  height: $fsize;
  min-width: $fsize;
  min-height: $fsize;
  border-radius: 50%;
  i {
    margin: 0 !important;
  }
  label {
    display: none;
  }
}
.button.fab.mini {
  $mfsize: 40px;
  width: $mfsize;
  height: $mfsize;
  min-width: $mfsize;
  min-height: $mfsize;
  label {
    display: none;
  }
  i {
    font-size: 24px !important;
  }
}
.button.fab.fav {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px;
  min-height: 24px;
  padding: 0;
  label {
    display: none;
  }
  i {
    font-size: 16px !important;
  }
}
.button.fab.mini.wide {
  $mfsize: 40px;
  width: 64px !important;
  height: $mfsize;
  min-width: $mfsize;
  min-height: $mfsize;
  border-radius: 64px !important;
  label {
    display: none;
  }
  i {
    font-size: 24px !important;
  }
}
.button.mini {
  i {
    font-size: 16px;
  }
  label {
    font-size: 12px;
  }
}
.button.fav {
  background-color: var(--normalText05) !important;
  i {
    color: var(--normalText5);
    font-size: 12px;
  }
  label {
    color: var(--normalText);
    font-size: 12px;
  }
}
// hovers
.button:hover {
  filter: brightness(110%);
}
.button.flat:hover {
  background-color: var(--normalText1) !important;
}
</style>
